export enum PreferToCommunicate {
    YOUNGER = 'youngeer',
    PEERS = 'peers',
    OLDER = 'older',
}

export const preferToCommunicateTranslates = {
    [PreferToCommunicate.YOUNGER]: 'common:form.labels.younger',
    [PreferToCommunicate.PEERS]: 'common:form.labels.peers',
    [PreferToCommunicate.OLDER]: 'common:form.labels.older',
};
